import { ProjectStatus } from '@constants/entities/project';
import useProjectId from '@hooks/useProjectId';
import { skipToken } from '@reduxjs/toolkit/query';
import { useGetOneProjectQuery } from '@store/services/projects';

/**
 * Whether the project is archived, which gates editing across the app. Holds
 * its own subscription so the answer never depends on another component
 * keeping the query alive; `selectFromResult` keeps consumers from re-rendering
 * on unrelated project fields.
 */
const useProjectArchived = (projectId?: string) => {
  const currentId = useProjectId();
  const id = projectId || currentId;

  const { isArchived } = useGetOneProjectQuery(id || skipToken, {
    selectFromResult: ({ data }) => ({
      isArchived: data?.status === ProjectStatus.Archived,
    }),
  });

  return isArchived;
};

export default useProjectArchived;
